export function filters() {
    const filterBtns = document.querySelectorAll('.m-filters__item-header');

    if (!filterBtns) return;

    let iTarget = null;

    filterBtns.forEach(btn => {
        btn.addEventListener('click', item => {
            iTarget = item.currentTarget;
            if (iTarget.classList.contains('active')) {

                iTarget.classList.remove('active')
                iTarget.nextElementSibling.classList.remove('active')
                iTarget.setAttribute('aria-expanded', 'false')
            } else {

                iTarget.classList.add('active')
                iTarget.nextElementSibling.classList.add('active')
                iTarget.setAttribute('aria-expanded', 'true')

            }
        });
    })

    const filterCheckbox = document.querySelectorAll('.m-filters__item-checkbox input');

    if (!filterCheckbox) return;

    filterCheckbox.forEach(btn => {
        btn.addEventListener('click', item => {
            $("#category-filters-id input.offset-value").val(0)
            $("#category-filters-id input.ajax-content-replace").val("1")
            $("#category-filters-id").submit();
        });
    })
    if ($("#category-filters-id").length > 0) {
        $("#category-filters-id").submit(function (e) {

            e.preventDefault(); // avoid to execute the actual submit of the form.

            var form = $(this);
            var actionUrl = form.attr('action');

            $.ajax({
                type: "POST",
                url: actionUrl,
                data: form.serialize(), // serializes the form's elements.
                success: function (data) {
                    if ($("#category-filters-id input.ajax-content-replace").val() == "1") {
                        $(".m-filters .m-filters__content .row").html(data);
                    } else {
                        $("#ajax-show-more").replaceWith(data);
                    }
                    if ($('#show-more-results-ajax').length > 0) {
                        $('#show-more-results-ajax').click(function (e) {
                            e.preventDefault();
                            $("#category-filters-id input.ajax-content-replace").val("0")
                            $("#category-filters-id input.offset-value").val(parseInt($("#category-filters-id input.offset-value").val()) + 20);
                            $("#category-filters-id").submit();
                        });
                    }
                }
            });
        });
    }
    if ($('#show-more-results-ajax').length > 0) {
        $('#show-more-results-ajax').click(function (e) {
            e.preventDefault();
            $("#category-filters-id input.ajax-content-replace").val("0")
            $("#category-filters-id input.offset-value").val(parseInt($("#category-filters-id input.offset-value").val()) + 20);
            $("#category-filters-id").submit();
        });
    }
}
